import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commercial-refrigeration',
  templateUrl: './commercial-refrigeration.component.html',
  styleUrls: ['./commercial-refrigeration.component.scss']
})
export class CommercialRefrigerationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/commercial-refrigeration/commercial-refrigeration.component.ts